<template>
  <img class="background">
</template>

<style scoped>
  .background {
    min-height: 100%; min-width: 100%;
    width: 100%; height: auto; position: fixed;
    top: 0; left: 0;
    z-index: -100;
    background-color: #1c1c1c;
  }
  @keyframes example {
    from { transform: scale(1.0) }
    to { transform: scale(1.20) }
  }
</style>
